import { useState, useEffect, useMemo } from 'react';
import { RootState } from 'store';
import { useSelector } from 'react-redux';
import api from 'services/api';

const useVideo = (initialVideoHashId: string, channelId: string, videoId: string): any => {
  const [video, setVideo] = useState(null as any);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null as any);

  const allVideos = useSelector((state: RootState) => state.userChannelVideo);
  const allActivities = useSelector((state: RootState) => state.userChannelActivity);
  const playlistVideos = useSelector((state: RootState) => state.channelPlaylists.channels);
  const selectVideo = useMemo(() => {
    return (
      allVideos[channelId]?.results.find((item: any) => item?.id === videoId) ||
      allActivities[channelId]?.results.find((item: any) => item?.content_object?.id === videoId)?.content_object ||
      playlistVideos[channelId]?.find((video: any) => video.id === videoId)
    );
  }, [videoId, allVideos, allActivities, playlistVideos]);

  useEffect(() => {
    if (initialVideoHashId && initialVideoHashId.trim() !== '') {
      if (!selectVideo) {
        getVideo(initialVideoHashId);
      }
    }
  }, [initialVideoHashId]);

  const getVideo = async (videoHashId: string) => {
    setLoading(true);
    try {
      const response = await api.get(`api/videos/${videoHashId}/info/`);
      setVideo(response.data); // Assuming response.data contains the video object
      setError(null);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  return {
    video,
    loading,
    error,
    selectVideo,
    allVideos,
    getVideo
  };
};

export default useVideo;
